import { Component, OnDestroy, OnInit } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { Observable, Subject } from 'rxjs';
import { switchMap, first, tap, finalize, takeUntil } from 'rxjs/operators';

import { AccountService } from '../../services/account.service';
import { ModalService } from '../../services/modal.service';

import { Account } from '../../models/account';
import { SiteService } from '../../services/site.service';
import _ from 'lodash';

@Component({
  selector: 'app-account-localitygroup-list',
  templateUrl: './account-localitygroup-list.component.html',
  styleUrls: ['./account-localitygroup-list.component.scss'],
})
export class AccountLocalityGroupListComponent implements OnInit, OnDestroy {
  private unsubscribe$ = new Subject<void>();

  account$: Observable<Account>;

  constructor(
    private siteService: SiteService,
    private modalService: ModalService,
    private accountService: AccountService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.account$ = this.accountService.account$;
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onEditLocality(event: Event, group: any): void {
    const localityGroupName = {
      input: group.name,
    };

    const modal = this.modalService.inputTextInput({
      title: 'Locality Group',
      buttons: [
        { label: 'Cancel', key: 'cancel', class: 'p-button-secondary' },
        { label: 'Save', key: 'save', class: '' },
      ],
      data: localityGroupName,
    });

    modal.onClose.subscribe({
      next: (reason: string) => {
        if (reason && reason.toString().toLowerCase() === 'save') {
          group.name = localityGroupName.input;
          this.updateAccountData();
        }
      },
    });
  }

  onDeleteLocalityGroup(group: any): void {
    this.accountService.account$
      .pipe(
        finalize(() =>
          this.siteService.setSubscriptionLogFinalised(
            'account-arrangement-locality-list.component.ts->updateAccountData->this.accountService.account$'
          )
        ),
        takeUntil(this.unsubscribe$),
        first((account) => account !== undefined)
      )
      .subscribe({
        next: (account) => {
          const localityGroupIndex = _.findIndex(
            account.data.localityGroup,
            (g: any) => g._meta.id === group._meta.id
          );

          if (localityGroupIndex >= 0) {
            if (account.data.localityGroup.length > 1) {
              account.data.localityGroup.splice(localityGroupIndex, 1);
            } else {
              account.data.localityGroup = null;
            }
          }
          this.accountService.patch(account.data).subscribe({
            next: (res) => {
              //console.log(res.data);
            },
          });
        },
      });
  }

  onDeleteLocality(event: Event, group: any): void {
    const modal = this.modalService.generic({
      title: 'Remove Item',
      copy: ['Are you sure you want to remove this locality?'],
      buttons: [
        { label: 'Cancel', key: 'cancel', class: '' },
        { label: 'Confirm', key: 'confirm', class: 'p-button-danger', icon: 'pi pi-trash' },
      ],
    });

    modal.onClose.subscribe({
      next: (reason: string) => {
        if (reason.toString().toLowerCase() === 'confirm') {
          this.onDeleteLocalityGroup(group);
          // this.updateAccountData();
        }
      },
    });
  }

  private updateAccountData(): void {
    this.siteService.addSubscriptionLog(
      this,
      'account-arrangement-locality-list.component.ts->updateAccountData->this.accountService.account$'
    );

    this.accountService.account$
      .pipe(
        finalize(() =>
          this.siteService.setSubscriptionLogFinalised(
            'account-arrangement-locality-list.component.ts->updateAccountData->this.accountService.account$'
          )
        ),
        takeUntil(this.unsubscribe$),
        first(),
        switchMap((account) => this.accountService.patch(account.data))
      )
      .subscribe({
        next: (res) => {
          // console.log(res.data);
        },
      });
  }
}
